import { Action, Reducer } from 'redux';
import {
  AffectedTypeActionTypes,
  AffectedTypeState,
  AffectedTypeTypes
} from './affectedTypeTypes';

export const INITIAL_STATE: AffectedTypeState = {
  affectedType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const affectedTypeReducer: Reducer<AffectedTypeState> = (
  state: AffectedTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as AffectedTypeActionTypes;
  switch (actionTypes.type) {
    case AffectedTypeTypes.GET_AFFECTED_TYPE:
      return {
        ...state,
        affectedType: { ...state.affectedType, isLoading: true }
      };
    case AffectedTypeTypes.SAVE_AFFECTED_TYPE:
      return {
        ...state,
        affectedType: {
          ...state.affectedType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case AffectedTypeTypes.RESET_REDUCER_AFFECTED_TYPE:
      return {
        ...state,
        affectedType: INITIAL_STATE.affectedType
      };
    default:
      return state;
  }
};

export default affectedTypeReducer;
